import React from "react";
import PromocioModel from "../components/promociosoldal/promocio";

const Promocio = () => {
  return <PromocioModel />;
};

export default Promocio;
